import { createTheme } from '@mantine/core';
import { BREAKPOINTS } from 'shared/config';
import { ActionIcon } from './action-icon';
import { Anchor } from './anchor';
import { Button } from './button';
import { Carousel } from './carousel';
import { CloseButton } from './close-button';
import { Divider } from './divider';
import { Drawer } from './drawer';
import { Input } from './input';
import { Modal } from './modal';
import { NumberFormatter } from './number-formatter';
import { Pagination } from './pagination';
import { Popover } from './popover';
import { Progress } from './progress';
import { Slider } from './slider';
import { Switch } from './switch';
import { Table } from './table';
import { Tabs } from './tabs';
import { TextInput } from './text-input';
import { Textarea } from './textarea';
import { Tooltip } from './tooltip';

export const theme = createTheme({
	fontFamily: 'var(--font-family)',
	fontSmoothing: true,
	cursorType: 'pointer',
	activeClassName: '',
	focusRing: 'never',
	breakpoints: {
		xs: `${BREAKPOINTS.xs + 1}px`,
		sm: `${BREAKPOINTS.sm + 1}px`,
		md: `${BREAKPOINTS.md + 1}px`,
		lg: `${BREAKPOINTS.lg + 1}px`,
		xl: `${BREAKPOINTS.xl + 1}px`,
		xxl: `${BREAKPOINTS.xxl + 1}px`,
	},
	components: {
		Button,
		ActionIcon,
		Pagination,
		Table,
		Tabs,
		Carousel,
		Anchor,
		Input,
		TextInput,
		Textarea,
		Slider,
		Switch,
		Modal,
		CloseButton,
		Drawer,
		Divider,
		NumberFormatter,
		Progress,
		Popover,
		Tooltip,
	},
});

export { Lighting } from './lighting';
